import React from 'react';

import { CommentOutlined } from '@ant-design/icons';

const NotificationCardConversationIcon = () => {
  return <CommentOutlined className="text-xl text-purple-500" />;
};

export default NotificationCardConversationIcon;
